export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Edit.vue?vue&type=template&id=05fd23c5"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Crews/Edit.vue?vue&type=template&id=05fd23c5
// module id = 2521
// module chunks = 31